var isMobile = false;
$(window).resize(function(){
    var topBarNav   = $('#nav-topbar');
    var mainNav     = $('#nav-mainnav');
    moveNavigation();
    
});
$(document).ready(function(){
    moveNavigation();
    $('.full-overlay, #hamburger-menu').click(function(){
        toggleDrawer();
    });
    $('#navigation-container .main-nav li.children').hover(function(){
        // $(this).children('.submenu').stop().slideDown().addClass('open').css('display', 'flex');
        $(this).children('.submenu').addClass('open');
    }, function(){
        // $(this).children('.submenu').stop().slideUp().removeClass('open');
        $(this).children('.submenu').removeClass('open');
    });
    $('#mobile-drawer .main-nav li.children a').click(function(){
        $(this).parent().children('.submenu').css('transform', 'translateX(0)').addClass('open');
    });
    $('#mobile-drawer .main-nav li.children ul.submenu li.close-item').click(function(){
        $(this).parent('.submenu').css('transform', 'translateX(100vh)').removeClass('open');
    });
    $('#mobile-drawer .main-nav li.close-item').click(function(){
        if(!$(this).parent().hasClass('submenu')) {
            toggleDrawer();
        }
    });
});
function moveNavigation() {
    if($('#hamburger-menu').is(':visible')) {
        isMobile = true;
        $('#nav-topbar').detach().appendTo('#mobile-drawer');
        $('#nav-mainnav').detach().appendTo('#mobile-drawer');
    } else {
        isMobile = false;
        $('#nav-topbar').detach().appendTo('#navigation-container');
        $('#nav-mainnav').detach().appendTo('#navigation-container');
    }
}
function toggleDrawer() {
    var md = $('#mobile-drawer');
    if(md.hasClass('open')) {
        $('.full-overlay').hide();
        md.css('transform', 'translateX(100vw)').removeClass('open');
    } else {
        $('.full-overlay').show();
        
        md.css('transform', 'translateX(1px)').addClass('open');
    }
}

document.addEventListener('DOMContentLoaded', () => { 
    // This is the bare minimum JavaScript. You can opt to pass no arguments to setup.
    const player = new Plyr('#player');
    
    // Expose
    window.player = player;
  
    // Bind event listener
    function on(selector, type, callback) {
      document.querySelector(selector).addEventListener(type, callback, false);
    }
});

	// Animation Formulaire contact.html
	$('input').focus(function(){
		$(this).parents('.form-group').addClass('focused');
	  });
	  
	  $('input').blur(function(){
		var inputValue = $(this).val();
		if ( inputValue == "" ) {
		  $(this).removeClass('filled');
		  $(this).parents('.form-group').removeClass('focused');  
		} else {
		  $(this).addClass('filled');
		}
      })
      document.addEventListener( 'wpcf7mailsent', function( event ) {
        location = 'https://www.sniper-zone.be/confirmation/';
    }, false );